module.exports = __webpack_public_path__ + "images/choose-a-field.png";